import type { NotificationSettings } from '~/modules/notifications'
import type { ProductSku } from '~/modules/product'

export const MESSAGE_EVENT = 'message'

/** Типы ивентов, которые игра получает от родителя */
export const EVENT_TO_LISTEN = {
  GET_PARAMS: 'GET_PARAMS',
  USER: 'USER',
  TOKEN: 'TOKEN',
  CHECK_USER_DATA_FILLED: 'CHECK_USER_DATA_FILLED',
  ADD_TO_FAVORITES_SUCCESS: 'ADD_TO_FAVORITES_SUCCESS',
  REMOVE_FROM_FAVORITES_SUCCESS: 'REMOVE_FROM_FAVORITES_SUCCESS',
  GET_CART_ITEMS_SKU_SUCCESS: 'GET_CART_ITEMS_SKU_SUCCESS',
  APP_INFO: 'APP_INFO',
} as const

/** Типы ивентов, которые игра отправляет родителю */
export const EVENT_TO_DISPATCH = {
  GET_PARAMS: 'GET_PARAMS',
  GET_USER: 'GET_USER',
  CHECK_USER_DATA_FILLED: 'CHECK_USER_DATA_FILLED',
  AUTH: 'AUTH',
  SHARE: 'SHARE',
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
  RELOAD: 'RELOAD',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  ADD_TO_CART: 'ADD_TO_CART',
  ADD_TO_FAVORITES: 'ADD_TO_FAVORITES',
  GET_CART_ITEMS_SKU: 'GET_CART_ITEMS_SKU',
  SWITCH_LOCALE: 'SWITCH_LOCALE',
  REMOVE_FROM_FAVORITES: 'REMOVE_FROM_FAVORITES',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  GET_APP_INFO: 'GET_APP_INFO',
} as const

export type EventListener<T> = (data: T) => void
export type Unsubscribe = () => void

export interface BridgeIncomingPayloads {
  [EVENT_TO_LISTEN.USER]: Record<string, unknown>
  [EVENT_TO_LISTEN.GET_PARAMS]: Record<string, unknown>
  [EVENT_TO_LISTEN.APP_INFO]: Record<string, unknown>
  [EVENT_TO_LISTEN.ADD_TO_FAVORITES_SUCCESS]: ProductSku
  [EVENT_TO_LISTEN.REMOVE_FROM_FAVORITES_SUCCESS]: ProductSku
  [EVENT_TO_LISTEN.GET_CART_ITEMS_SKU_SUCCESS]: string[]
  [EVENT_TO_LISTEN.CHECK_USER_DATA_FILLED]: Record<string, boolean>
}

export interface BridgeOutgoingPayloads {
  [EVENT_TO_DISPATCH.OPEN]: { url: string }
  [EVENT_TO_DISPATCH.CLOSE]: { url: string }
  [EVENT_TO_DISPATCH.SHARE]: { url: string }
  [EVENT_TO_DISPATCH.SWITCH_LOCALE]: { code: string }
  [EVENT_TO_DISPATCH.ADD_TO_CART]: ProductSku
  [EVENT_TO_DISPATCH.ADD_TO_FAVORITES]: ProductSku
  [EVENT_TO_DISPATCH.REMOVE_FROM_FAVORITES]: ProductSku
  [EVENT_TO_DISPATCH.SHOW_NOTIFICATION]: NotificationSettings
  [EVENT_TO_DISPATCH.GET_USER]: undefined
  [EVENT_TO_DISPATCH.GET_PARAMS]: undefined
  [EVENT_TO_DISPATCH.GET_APP_INFO]: undefined
  [EVENT_TO_DISPATCH.RELOAD]: undefined
  [EVENT_TO_DISPATCH.AUTH]: undefined
  [EVENT_TO_DISPATCH.CHECK_USER_DATA_FILLED]: undefined
  [EVENT_TO_DISPATCH.GET_CART_ITEMS_SKU]: undefined
  [EVENT_TO_DISPATCH.REFRESH_TOKEN]: undefined
}

export interface MessageEvent {
  data?: {
    name?: string
    data?: unknown
  }
}

export interface AppInfoData {
  debug: boolean
  deviceId: string
  baseUrl: string
  [key: string]: unknown
}
